import React from 'react';
import './Tab.css';
import { Tabs, Select, Space } from 'antd';
import Gall from './Gallery'

const { TabPane } = Tabs;
const { Option } = Select;

let brakePoints = [350, 500, 750];
let images1 = [
    'https://source.unsplash.com/I1ASdgphUH4/800x599',
    'https://source.unsplash.com/2ShvY8Lf6l0/800x599',
    'https://source.unsplash.com/Dm-qxdynoEc/800x799',
    'https://source.unsplash.com/qDkso9nvCg0/600x799',
    'https://source.unsplash.com/iecJiKe_RNg/600x799',
    'https://source.unsplash.com/epcsn8Ed8kY/600x799',
    'https://source.unsplash.com/NQSWvyVRIJk/800x599',
    'https://source.unsplash.com/zh7GEuORbUw/600x799',

];

let images2 = [
    'https://source.unsplash.com/2ShvY8Lf6l0/800x599',
    'https://source.unsplash.com/Dm-qxdynoEc/800x799',
    'https://source.unsplash.com/qDkso9nvCg0/600x799',
    'https://source.unsplash.com/iecJiKe_RNg/600x799',
    'https://source.unsplash.com/epcsn8Ed8kY/600x799',
    'https://source.unsplash.com/NQSWvyVRIJk/800x599',
    'https://source.unsplash.com/zh7GEuORbUw/600x799',
];





class Tab extends React.Component {
    state = {
        tabPosition: 'top',
    };

    changeTabPosition = tabPosition => {
        this.setState({ tabPosition });
    };

    render() {
        return (
            <div>

                <Tabs tabPosition={this.state.tabPosition}>
                    <TabPane tab="Development" key="1">
                        <Gall images={images1} brakePoints={brakePoints} />
                    </TabPane>
                    <TabPane tab="CodeInclusive" key="2">
                        <Gall images={images2} brakePoints={brakePoints} />
                    </TabPane>

                </Tabs>
            </div>
        );
    }
}

export default Tab;
